import type { Configuration } from '@azure/msal-browser'
import { LogLevel } from '@azure/msal-browser'
import { ConnectionSettings } from '@microsoft/agents-copilotstudio-client'
import { ScopeHelper } from '@microsoft/agents-copilotstudio-client'
import { appConfig } from './appConfig'

/**
 * MSAL configuration for interactive Microsoft Entra authentication.
 * Uses sessionStorage (not localStorage) so tokens do not persist beyond
 * the browser tab/session, and in-memory token caching wherever possible.
 */
export const msalConfig: Configuration = {
  auth: {
    clientId: appConfig.entraClientId,
    authority: `https://login.microsoftonline.com/${appConfig.entraTenantId}`,
    redirectUri: appConfig.entraRedirectUri,
    postLogoutRedirectUri: appConfig.entraRedirectUri,
  },
  cache: {
    cacheLocation: 'sessionStorage',
  },
  system: {
    loggerOptions: {
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) return
        if (level === LogLevel.Error) console.error(message)
      },
      logLevel: LogLevel.Warning,
    },
  },
}

/** Connection settings for the SOC-Copilot Copilot Studio agent. */
export const copilotConnectionSettings = new ConnectionSettings({
  directConnectUrl: appConfig.copilotDirectConnectUrl,
})

/** The OAuth scope required to invoke the Copilot Studio agent. */
export const copilotScope = appConfig.copilotDirectConnectUrl
  ? ScopeHelper.getScopeFromSettings(copilotConnectionSettings)
  : 'https://api.powerplatform.com/.default'

/** Delegated scopes requested during interactive sign-in. */
export const loginRequest = {
  scopes: [copilotScope],
  // Redirect flow returns to the app root (msalConfig.auth.redirectUri),
  // which handleRedirectPromise processes on load to complete sign-in.
  redirectUri: appConfig.entraRedirectUri,
}

/**
 * Scope for the app's own conversations API (persistence backend). Acquired
 * silently after sign-in; admin consent for this scope means no extra prompt.
 */
export const apiRequest = {
  scopes: appConfig.apiScope ? [appConfig.apiScope] : [],
  redirectUri: appConfig.entraRedirectUri,
}
